import type React from 'react'

/**
 * Unified Table Wrapper Component
 * Ultra-lightweight container with barely-there border and minimal shadow
 */
export const TableWrapper: React.FC<{
    children: React.ReactNode
    className?: string
    style?: React.CSSProperties
}> = ({ children, className = '', style }) => {
    return (
        <div
            className={`w-full max-w-full rounded-2xl bg-white dark:bg-slate-950 shadow-[0_1px_3px_rgba(0,0,0,0.04),0_4px_20px_-8px_rgba(0,0,0,0.05)] dark:shadow-[0_1px_3px_rgba(0,0,0,0.2),0_4px_20px_-8px_rgba(0,0,0,0.3)] border border-slate-100 dark:border-slate-800/60 overflow-hidden ${className}`}
            style={style}
        >
            {children}
        </div>
    )
}
